module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
    attrs: {
      "title": "Usuários"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "el-card__save_form box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Dados do Usuário")])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "20%"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSend($event)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.ref_pessoa.$error
    },
    attrs: {
      "label": "Matrícula"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        _vm.$v.form.ref_pessoa.$touch()
      }
    },
    model: {
      value: (_vm.form.ref_pessoa),
      callback: function($$v) {
        _vm.$set(_vm.form, "ref_pessoa", $$v)
      },
      expression: "form.ref_pessoa"
    }
  }), _vm._v(" "), (_vm.$v.form.ref_pessoa.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.form.pessoa, "nome", $$v)
      },
      expression: "form.pessoa.nome"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Perfis do Usuário"
    }
  }, [_c('el-transfer', {
    attrs: {
      "data": _vm.dependencies.roles,
      "titles": ['Disponíveis', 'Selecionados'],
      "props": {
        key: 'id',
        label: 'name'
      }
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
    attrs: {
      "event-click": _vm.onSend,
      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
      "is-submitted": _vm.isSubmitted
    }
  }), _vm._v(" "), _c('form-cancel-button', {
    attrs: {
      "route-name": "user.index"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86a256c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/user/components/Form.vue
// module id = 776
// module chunks = 2